import { Badge, Box, Icon, IconButton } from '@wegroup/design-system';
import React from 'react';
import { useLouiseSelector } from '../../../store/redux/store';
import useOffersPageParams from '../../offers/hooks/useOffersPageParams';

interface Props {
  onClick: () => void;
}

const CompareOffersHoverButton: React.FC<Props> = ({ onClick }) => {
  const { riskObject } = useOffersPageParams();
  const comparisonOffers = useLouiseSelector(
    (state) => state.offers.comparisonMatrixOffers,
  );

  const amountOfComparisonOffers = comparisonOffers[riskObject || '']?.length;

  return (
    <Box
      position="fixed"
      bottom="4"
      left="4"
      borderRadius="full"
      zIndex="2"
      boxShadow="rgba(0, 0, 0, 0.1) 0px 1px 4px, rgba(0, 0, 0, 0.2) 0px 2px 12px"
    >
      <Badge
        pos="absolute"
        top="0"
        right="0"
        transform="translate(25%,-25%)"
        zIndex="2"
      >
        {amountOfComparisonOffers}
      </Badge>
      <IconButton
        variant="secondary"
        size="lg"
        icon={<Icon name="GeneralActionsCompare" />}
        aria-label="Compare offers"
        onClick={onClick}
        borderRadius="full"
        isDisabled={amountOfComparisonOffers < 2}
      />
    </Box>
  );
};

export default CompareOffersHoverButton;
